import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";
import { ELSSkeleton } from "components/common/elsevier/Skeleton/Skeleton";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import styles from "./Styles.module.scss";
function Skeleton(props) {
  return /*#__PURE__*/React.createElement(ELSGrid, _extends({
    className: "".concat(styles.skeleton, " ev-quick-skeleton-container"),
    container: true,
    justifyContent: "center"
  }, props), /*#__PURE__*/React.createElement(ELSGrid, {
    className: "ev-quick-skeleton-search",
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    margin: "0 auto",
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    className: "ev-quick-skeleton-title"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 580,
    height: 29
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 374,
    height: 29
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: "24px",
    className: "ev-quick-skeleton-fields"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    sx: {
      margin: "0 0 10px 0"
    },
    variant: "rounded",
    width: "100%",
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: "100%",
    height: 46
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    sx: {
      margin: "0 0 10px 0"
    },
    variant: "rounded",
    width: "100%",
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: "100%",
    height: 46
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: "24px"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 9,
    className: "ev-quick-skeleton-options"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 14,
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 106,
    height: 10
  })), /*#__PURE__*/React.createElement("div", {
    className: "ev-quick-skeleton-submit"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 210,
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 106,
    height: 48
  }))), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }))))), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    maxWidth: "lg",
    margin: "70px auto 0"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    xs: 1.5,
    item: true
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    xs: 9,
    item: true
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    className: "ev-quick-skeleton-history-title",
    variant: "rounded",
    width: 180,
    height: 17
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: "100%",
    height: 1
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles.skeleton__historyRow
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 106,
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 113,
    height: 10
  })), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: "100%",
    height: 1
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles.skeleton__historyRow
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 300,
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 113,
    height: 10
  })), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: "100%",
    height: 1
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles.skeleton__historyRow
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 130,
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 113,
    height: 10
  })), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: "100%",
    height: 1
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    className: styles.skeleton__historyViewMore
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 106,
    height: 10
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rounded",
    width: 14,
    height: 10
  }))), /*#__PURE__*/React.createElement(ELSGrid, {
    xs: 1.5,
    item: true
  }))));
}
export default Skeleton;